import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {
    Button,
    Checkbox,
    CircularProgress,
    Container,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    FormControl,
    FormControlLabel,
    Grid,
    MenuItem,
    Select,
    TextField,
    InputLabel
} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {ConsigneeService, CountryService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const ConsigneeForm = () => {
    const methods = useForm();
    const [data, setData] = useState({});
    const [isReady, setIsReady] = useState(false);
    const [countryList, setCountryList] = useState([]);
    const {showMessage, showError} = useContext(NotificationContext);
    const {id} = useParams();
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const {rights} = useContext(CurrentUserContext);
    const [showProgress, setShowProgress] = useState(false);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
      const [isVisibleDialog, setVisibleDialog] = useState(false);

    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );

      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }

    const removeConsignee = () => {
        setShowProgress(true);
        ConsigneeService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/references/consignees");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }

      
      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {

        CountryService.getAll()
            .then((response) => setCountryList(response.data));

        if (id !== "new") {
            ConsigneeService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({country: {}});
            setIsReady(true);
        }
    }, [id]);


    const {handleSubmit, control, ref, errors} = methods;
    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            ConsigneeService.update({...data, ...d})
                .then((response) => {
                    showMessage('Consignee updated.')
                }).catch((response) => {
                    showError(response.message)
                });
        } else {
            ConsigneeService.create({...data, ...d})
                .then((response) => {
                    setData(response.data);
                    showMessage('Consignee Created.');
                });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/references/consignees')
        }, 100) 
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }

    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <Container>
            <header>
                <h1>Consignee</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <Controller
                            name="consigneeName"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Consignee Name"
                            color="primary"
                            rules={{required: 'Consignee Name is required.'}}
                            variant="outlined"
                            defaultValue={data.consigneeName}
                        />
                        <ValidationError error={errors.consigneeName}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    {/* <Grid item xs={6}>
                        <Controller
                            name="oneNetCode"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="One Network Code"
                            color="primary"
                            rules={{required: 'One Network Code is required.'}}
                            variant="outlined"
                            defaultValue={data.oneNetCode}
                        />
                        <ValidationError error={errors.oneNetCode}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid> */}
                    <Grid item xs={6}>
                        <FormControl>
                        <InputLabel id="test-select-label">Country</InputLabel>
                            <Controller
                                variant="outlined"
                                control={control}
                                name="country.id"
                                label="Country"
                                rules={{required: 'Country is required.'}}
                                defaultValue={data.country.id}
                                as={
                                    <Select ref={ref} label="Country" style={{minWidth: 300}} id="country">
                                        {
                                            countryList.map((option) => {
                                                return <MenuItem key={option.id} value={option.id}>
                                                    {option.countryName}
                                                </MenuItem>
                                            })
                                        }
                                    </Select>
                                }
                            />
                        </FormControl>
                        {errors.country && <ValidationError error={errors.country.id}/>}
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="address"
                            control={control}
                            as={TextField}
                            fullWidth
                            label="Address"
                            rules={{required: 'Address is required.'}}
                            color="primary"
                            multiline
                            rows={6}
                            variant="outlined"
                            defaultValue={data.address}
                            render={({onChange, value}) => <TextField
                                autoComplete="address"
                                value={value}
                            />}
                        />
                        <ValidationError error={errors.address}/>
                    </Grid>
                    <Grid item xs={6}>
                    </Grid>

                    <Grid item xs={6}>
                        <FormControlLabel label="Europallet Required?" variant="outlined" control={
                            <Controller
                                name="euroPalletRequired"
                                control={control}
                                fullWidth
                                color="primary"
                                defaultValue={data.euroPalletRequired}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>
                    <Grid item xs={10}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&    
                        <Grid item xs={2}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove Consignee</Button>
                        </Grid>
                      }
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this consignee?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeConsignee} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This consignee can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </Container>
    );
};

export default ConsigneeForm;
